import { ActionType, TableColumn } from "../../../../Component/Model/Table/Table";
import { ActionsCell } from "../../../../Component/Common/Components/DataTable/ActionsCell";
import { DefaultCell } from "../../../../Component/Common/Components/DataTable/DefaultCell";
import { BeeScorecardLicense } from "../../../../Component/Model/Dto/ScorecardLicense";

interface ScorecardLicenseSummaryRows {
    id: number;
    scorecardTypeName: string;
    isConsolidated: string;
    numberOfLicences: number;
    numberOfAvailableScorecards: number;
    actions: ActionType[];
}

interface ScorecardLicenseSummaryTable {
    columns: Array<TableColumn>;
    rows: Array<ScorecardLicenseSummaryRows>;
}

export function ScorecardLicenseModalSummaryTableMapper(dataObject: BeeScorecardLicense[], handleCreateScorecard: (id: string, IsConsolidated: boolean) => void, isGrouped:boolean): ScorecardLicenseSummaryTable {

    const columns = [
        { Header: 'Scorecard Type', accessor: 'scorecardTypeName', id:'ScorecardTypeName', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Consolidated Scorecard', accessor: 'isConsolidated', id:'isConsolidated', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Number Of Licenses', accessor: 'numberOfLicences', id:'numberOfLicences', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Number Of Available Scorecards', accessor: 'numberOfAvailableScorecards', id:'numberOfAvailableScorecards', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Actions', accessor: 'actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true },
    ];
    if (dataObject.length > 0) {
        const rows = dataObject.map((item: BeeScorecardLicense, index: number) => ({
            id: item.scorecardTypeId,
            scorecardTypeName: item.scorecardTypeName,
            isConsolidated: item.isConsolidated ? 'Yes' : 'No',
            numberOfLicences: item.numberOfLicences,
            numberOfAvailableScorecards: item.numberOfAvailableScorecards,
            actions: item.numberOfAvailableScorecards > 0 ? [
                {
                    key: item.nextScorecardLicenseIdToUse,
                    label: isGrouped ? 'Create New Module' : 'Create New Scorecard',
                    action: () => { handleCreateScorecard(item.nextScorecardLicenseIdToUse, item.isConsolidated) },
                    icon: {
                        name: 'add_box  ',
                        color: 'info',
                    }
                }
            ] : [
                {
                    key: item.nextScorecardLicenseIdToUse,
                    label: 'No licenses available',
                    action: () => { },
                    icon: {
                        name: 'do_disturb ',
                        color: 'error',
                    }
                }
            ]
        }));
        return { columns: columns, rows: rows };
    }
    else {
        return { columns: columns, rows: [] };
    }
}